"use client"

import React from "react"
import ReusableHomeSearchInput from "./reusable-home-search-input"

interface MapSearchHomeInputProps {
  onSelectHouse?: (houseId: string | null) => void
}

function MapSearchHomeInput({ onSelectHouse }: MapSearchHomeInputProps) {
  return (
    <ReusableHomeSearchInput
      onSelectHouse={onSelectHouse}
      placeholder="Search homes by name, address, or phone number..."
      emptyText="No homes found."
      showSelectedCard={false}
      updateUrl={true}
    />
  )
}

export default MapSearchHomeInput
